import { all, takeLatest, fork } from 'redux-saga/effects';
import requestAuthorization from '../actions/requestAuthorization';
import requestLogout from '../actions/requestLogout';
import authorizeSaga from './authorizeSaga';
import unauthorizeSaga from './unauthorizeSaga';
import requestUserData from '../actions/requestUserData';
import getCurrentUserSaga from './getCurrentUserSaga';
import authorizationSuccess from '../actions/authorizationSuccess';
import newApprovalsApproved from '../actions/newApprovalApproved';
import newApprovalsDenied from '../actions/newApprovalDenied';
import stagesWellSelectionSuccess from '../actions/stagesWellSelectionSuccess';
import deleteStages from '../actions/deleteStages';
import activeNewSofwareVersion from '../actions/activeNewSofwareVersion';
import loadBadgeCountSaga from './loadBadgeCountSaga';

function* actionWatcher() {
    yield takeLatest(requestAuthorization.type, authorizeSaga);
    yield takeLatest(requestLogout.type, unauthorizeSaga);
    yield takeLatest([requestUserData.type, authorizationSuccess.type], getCurrentUserSaga);
    yield takeLatest(
        [
            newApprovalsApproved.type,
            newApprovalsDenied.type,
            stagesWellSelectionSuccess.type,
            deleteStages.type,
            activeNewSofwareVersion.type,
        ],
        loadBadgeCountSaga,
    );
    yield fork(loadBadgeCountSaga);
}

export default function* rootSaga() {
    yield all([actionWatcher()]);
}
